<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const activeTab = computed(() => store.getters.activeTab);
const activeUser = computed(() => store.state.user.activeUser);

const setTab = (tab) => {
  store.dispatch('setTab', tab);
};
</script>

<template>
  <div class="ce-searchResultTypeSelection">
    <button
      :class="{active: activeTab === 'search'}"
      @click.prevent="setTab('search')">
      {{ $t('productSearch.tabs.search') }}
    </button>

    <button
      v-if="activeUser"
      :class="{active: activeTab === 'favorites'}"
      @click.prevent="setTab('favorites')">
      {{ $t('productSearch.tabs.favorites') }}
    </button>

    <tooltip
      class="disabled"
      v-else
      :content="$t('productSearch.favoriteAction.loginForFavorites')">
      <button
        class="disabled"
        @click.prevent>
        {{ $t('productSearch.tabs.favorites') }}
      </button>
    </tooltip>
  </div>
</template>
